import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Radio, RadioChangeEvent } from 'antd';
import { useState } from 'react';

export type DownloadType = 'Payroll' | 'request' | 'response';

type SelectDataTypeModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSelect: (type: DownloadType) => void;
  showPayroll?: boolean;
  loading?: boolean;
  title?: string;
  confirm?: string;
};

export const SelectDataTypeModal = ({
  isOpen,
  toggle,
  onSelect,
  showPayroll = false,
  loading = false,
  title = '',
  confirm = '',
}: SelectDataTypeModalProps) => {
  const { messages } = useTypedIntl();
  const [valueRadio, setValueRadio] = useState<DownloadType>(
    showPayroll ? 'Payroll' : 'request',
  );

  const onChange = (e: RadioChangeEvent) => {
    setValueRadio(e.target.value);
  };

  return (
    <AppModalContainer
      title={title || messages['revenue.psr.downloadType.title']}
      isOpen={isOpen}
      width={400}
      minHeight="200px"
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          buttonType: 'primary',
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.apply'],
          buttonType: 'primary',
          loading: loading,
          onClick: () => {
            onSelect(valueRadio);
          },
        },
      ]}
    >
      <div>
        <div className="mb-4">
          {confirm || messages['revenue.psr.downloadType.confirm']}
        </div>
        <Radio.Group onChange={onChange} value={valueRadio}>
          <Radio value="request">{messages['common.request']}</Radio>
          <Radio value="response">{messages['common.response']}</Radio>
          {showPayroll && (
            <Radio value="Payroll">{messages['common.payroll']}</Radio>
          )}
        </Radio.Group>
      </div>
    </AppModalContainer>
  );
};

export default SelectDataTypeModal;
